import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../../interfaces/response";

export type TIdentityVerificationType = {
  id: number;
  name: string;
};

const getIdentityVerificationTypes = async (): Promise<
  IResponse<TIdentityVerificationType[]>
> => {
  const { data } = await getData(ajaxEndpoints.GOVERNMENT_ISSUE_ID_TYPES);
  return data;
};

export function useIdentityVerificationTypes() {
  return useQuery<IResponse<TIdentityVerificationType[]>>(
    ["identityVerificationTypes"],
    getIdentityVerificationTypes,
    {
      refetchOnWindowFocus: false,
    }
  );
}
